const options = [
    { Id: 1, Nombre: "Argentino", Value: 1 },
    { Id: 2, Nombre: "Urbano", Value: 2 }
]

export default options;